export default function Spinner() {
  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <div className="size-12 animate-spin rounded-full border-2 border-b-background border-l-secondary border-r-primary border-t-transparent shadow-md" />
    </div>
  );
}
